export function getEnv() {
  return process.env.NEXT_PUBLIC_ENV || "local";
}
